import { Breadcrumbs, type BreadcrumbsList } from "@ui/eva-components/Breadcrumbs";
import type { LogoProps } from "@ui/eva-components/Logo";
import { Logo } from "@ui/eva-components/Logo";
import { type RenderLinkProps } from "@ui/eva-components/types/RenderLinkProps.type";

import styles from "./FooterBreadcrumbs.module.scss";

export type BreadcrumbsProps = {
  logoProps: LogoProps;
  list: BreadcrumbsList;
} & RenderLinkProps;

export const FooterBreadcrumbs = ({ list, logoProps }: BreadcrumbsProps) => {
  if (!list?.length) {
    return null;
  }

  const [root] = list;

  return (
    <div className={styles.listContainer}>
      <Logo {...logoProps} className={styles.logo} link={root.url} />
      <Breadcrumbs list={list} isAutomaticallyExpanded={true} className={styles.breadcrumbs} />
    </div>
  );
};
